/**
 * The name a downloaded document is saved under: the server's generated one, "Lastname, Firstname - Type - date.ext"
 * (132; Arthur, 19 October), read from Content-Disposition, its UTF-8 form first. A leaf module, tested in
 * web/test/document-name.test.ts.
 */
export function fileName(disposition: string | null): string {
  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(disposition ?? '')?.[1];
  if (utf8) { try { return decodeURIComponent(utf8); } catch { /* fall through */ } }
  return /filename="([^"]*)"/i.exec(disposition ?? '')?.[1] ?? 'Document';
}
